export default {
    validation: {
        required: 'required',
        invalidEmailFormat: 'invalid email format'
    }
};
